<template>
  <span class="lp-badge" :class="rootClasses">
    <slot />
    <span v-if="show" class="lp-badge-body" :class="bodyClasses">
      {{ contentValue }}
    </span>
  </span>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { Colors, Positions } from '@/models/enums'
import { colorType } from '@/models/types/'

defineOptions({
  name: 'lp-badge',
})

interface Props {
  type?: colorType
  position?: Positions
  value?: string | number | null
  maxValue?: number | null
  show?: boolean
  point?: boolean
  square?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  type: Colors.DANGER,
  position: Positions.TR,
  value: null,
  maxValue: null,
  show: true,
  point: false,
  square: false,
})

const slots = useSlots()

const contentValue = computed(() => {
  if (props.point || !props.value) return
  return props.maxValue !== null
    ? Number(props.value) > props.maxValue
      ? `${props.maxValue}+`
      : props.value
    : props.value
})

const rootClasses = computed(() => ({
  'lp-badge-sq': props.square,
}))

const bodyClasses = computed(() => ({
  ...(slots.default
    ? { [`lp-badge-body-corner-${props.position}`]: true }
    : null),
  'lp-badge-body-sq': props.square,
  'lp-badge-body-point': props.point,
  [`lp-badge-body-${props.type}`]: true,
}))
</script>
